module.exports = __webpack_public_path__ + "media/images/weather/240_night-6d2cfa9370529e57e93d37383b548986.png";